import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined

export function initSentry() {
  if (!DSN) {
    console.warn('Sentry DSN not configured — error monitoring disabled')
    return
  }

  Sentry.init({
    dsn: DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  })
}

export function setSentryUser(uid: string, email?: string | null) {
  Sentry.setUser({ id: uid, email: email || undefined })
}

export function clearSentryUser() {
  Sentry.setUser(null)
}

export { Sentry }
